import React, { useState } from 'react'

import { useUser } from '@/react-query/user'
import { IInterviewContext } from '@/views/screens/Interview/context/InterviewData/types'

export const InterviewDataContext = React.createContext<IInterviewContext>(
  {} as IInterviewContext,
)

export const InterviewDataProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { data: user } = useUser()

  const isReadOnly: boolean = (user?.availableInterviewTranscriptions || 0) <= 0
  const [file, setFile] = useState<File | undefined>()

  const [fileUploadProgress, setFileUploadProgress] = useState<number>(0)
  const [isFileUploading, setIsFileUploading] = useState(false)

  return (
    <InterviewDataContext
      value={{
        isReadOnly,
        file,
        setFile,
        fileUploadProgress,
        setFileUploadProgress,
        isFileUploading,
        setIsFileUploading,
      }}
    >
      {children}
    </InterviewDataContext>
  )
}
